import { render, staticRenderFns } from "./dialog-user-changepassword.vue?vue&type=template&id=3c854bbb&scoped=true&"
import script from "./dialog-user-changepassword.vue?vue&type=script&lang=js&"
export * from "./dialog-user-changepassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c854bbb",
  null
  
)

export default component.exports